import Vue from 'vue'
import {resizeImage} from '../utils'
import {NOTIFICA_SUCCESSO, NOTIFICA_ERRORE} from '../costanti'

export const UPLOAD_TYPE_IMAGE = 'image'

export default {
    namespaced: true,
    state: {
        stagedFiles: []
    },
    mutations: {
        ADD_STAGED_FILE: (state, file) => (state.stagedFiles.push({data: file})),
        ADD_URL_TO_STAGED_FILE: (state, {file, url}) => (state.stagedFiles.find(item => item.data.id === file.id).url = url),
        UPDATE_FILE_UPLOAD_PROGRESS: (state, {file, percentageCompleted}) =>
            (Vue.set(state.stagedFiles.find(item => item.data.id === file.id), 'progress', percentageCompleted)),
        RESET_STAGED_FILES: state => {
            state.stagedFiles = []
        }
    },
    actions: {
        async clientUpload({commit, dispatch}, file) {
            // otherwise we loop through the files uploaded
            let imageToUpload = null
            // if it's an image we set up a new object and add important info
            if (file.type.startsWith('image/')) {
                imageToUpload = await resizeImage({file, maxSizePx: 500})
                imageToUpload.name = file.name
                imageToUpload.id = new Date().getTime()
            }
            commit('ADD_STAGED_FILE', imageToUpload || file)
            dispatch('getSignedRequest', imageToUpload || file)
        },

        async getSignedRequest({commit, dispatch}, file) {
            try {
                const response = await Vue.axios.get(`/s3/sign_s3/`, {
                    params: {
                        file_name: file.name,
                        file_type: file.type
                    }
                })
                const dispatchParams = {file, s3Data: response.data}
                return dispatch('amazonPostRequest', dispatchParams)
            } catch (err) {
                console.log(err)
            }
        },

        async amazonPostRequest({commit, dispatch}, {file, s3Data}) {
            const bucketLink = s3Data.url
            const pathToFile = s3Data.fields.key
            const url = (bucketLink + '/' + pathToFile).replace(/ /g, '+')
            const postData = new FormData() // => data to post
            Object.keys(s3Data.fields).forEach(key => {
                postData.append(key, s3Data.fields[key])
            })
            postData.append('file', file) // => file to post

            try {
                await Vue.axios.post(bucketLink, postData, {
                    headers: {Authorization: ' '},
                    // creates the progress bar
                    onUploadProgress: progressEvent => {
                        const percentageCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
                        console.log(percentageCompleted)
                        if (progressEvent.loaded === progressEvent.total)
                            commit('ADD_URL_TO_STAGED_FILE', {file, url})
                    }
                })
                dispatch(
                    'modal/showNotification',
                    {
                        name: NOTIFICA_SUCCESSO,
                        title: 'Immagine caricata con successo'
                    },
                    {root: true}
                )
            } catch (err) {
                dispatch(
                    'modal/showNotification',
                    {
                        name: NOTIFICA_ERRORE,
                        title: `Errore nel caricare l'immagine`
                    },
                    {root: true}
                )
                console.error(err)
            }
        }
    }
}
